export class PriceRuleLocationLocationGroupView {
    public locationGroupId: string;
    public locationGroupName: string;
}